var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0898 7.77405V19.1341C20.0898 20.5841 19.0498 21.1941 17.7798 20.4941L13.8499 18.3041C13.4299 18.0741 12.7498 18.0741 12.3298 18.3041L8.39984 20.4941C7.12984 21.1941 6.08984 20.5841 6.08984 19.1341V7.77405C6.08984 6.06405 7.48983 4.66406 9.19983 4.66406H16.9798C18.6898 4.66406 20.0898 6.06405 20.0898 7.77405Z",
    stroke: "#FD9C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.fafb3243a6571b74ed8450f269b48d7a.svg";
export { ForwardRef as ReactComponent };